import { render, staticRenderFns } from "./PostError.vue?vue&type=template&id=47a652c1&"
import script from "./PostError.vue?vue&type=script&lang=js&"
export * from "./PostError.vue?vue&type=script&lang=js&"
import style0 from "./PostError.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports